import { FC } from 'react';
import { Flex, Tag, Text } from '@chakra-ui/react';
import { InfoPopover } from './info-popover';

export type InfoTag = {
  label: string;
  info: string;
};

type PlainOrInfoTagsProps = {
  tags: string[] | InfoTag[];
  testId?: string;
};

export const PlainOrInfoTags: FC<PlainOrInfoTagsProps> = ({ tags, testId }) => {
  // Split for Typescript
  const isContentPlain = typeof tags[0] === 'string';
  const plainTags = isContentPlain ? (tags as string[]) : [];
  const infoTags = !isContentPlain ? (tags as InfoTag[]) : [];

  if (plainTags.length > 0) {
    return (
      <Flex gridGap={2} wrap="wrap">
        {plainTags.map((tag) => (
          <Tag key={tag} size="lg" data-testid={testId}>
            {tag}
          </Tag>
        ))}
      </Flex>
    );
  }

  if (infoTags.length > 0) {
    return (
      <Flex gridGap={2} wrap="wrap">
        {infoTags.map((tag) => (
          <Tag key={tag.label} size="lg" data-testid={testId}>
            <Text mr={2}>{tag.label}</Text>
            <InfoPopover header={`${tag.label} policy`} info={tag.info} />
          </Tag>
        ))}
      </Flex>
    );
  }

  return null;
};
